"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.arrowColors = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _designTokens = _interopRequireDefault(require("@decisiv/design-tokens"));

var _color = _interopRequireDefault(require("../../modifiers/color"));

var _commonUIColors = require("../../utils/commonUIColors");

var _utils = require("./utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var baseColors = _designTokens.default.color.base,
    skyPlane = _designTokens.default.skyplanes.alias;
var bottomSideStyles = (0, _styledComponents.css)(["top:0;left:0;"]);
var topSideStyles = (0, _styledComponents.css)(["bottom:0;left:0;&::after{bottom:100%;}"]);
var rightSideStyles = (0, _styledComponents.css)(["left:0;"]);
var leftSideStyles = (0, _styledComponents.css)(["right:0;&::after{right:100%;}"]);
var sideStyles = {
  bottom: bottomSideStyles,
  left: leftSideStyles,
  right: rightSideStyles,
  top: topSideStyles
};

var getArrowDimensions = function getArrowDimensions(side) {
  var width = _constants.arrowSize.base + _constants.arrowShadowBlur;
  var height = _constants.arrowSize.height;
  return ['top', 'bottom'].includes(side) ? {
    width: width,
    height: height
  } : {
    width: height,
    height: width
  };
};

var arrowColors = _objectSpread({
  charcoal: baseColors.charcoal
}, _commonUIColors.commonUIColors);

exports.arrowColors = arrowColors;

var getDynamicStyles = function getDynamicStyles(_ref) {
  var placement = _ref.placement,
      hidden = _ref.hidden;

  var _getPlacementParts = (0, _utils.getPlacementParts)(placement),
      _getPlacementParts2 = _slicedToArray(_getPlacementParts, 1),
      side = _getPlacementParts2[0];

  var dimensions = getArrowDimensions(side); // We still render the arrow, but hide it instead, because we want popper.js
  // to think it is there so that changes to `showArrow` don't mess up the math.

  var visibility = hidden ? 'hidden' : 'visible';
  return (0, _styledComponents.css)(["height:", "px;width:", "px;visibility:", ";", ""], dimensions.height, dimensions.width, visibility, sideStyles[side]);
};

var colorModifiers = function colorModifiers(_ref2) {
  var color = _ref2.color;
  return (0, _color.default)(color && color in arrowColors ? arrowColors[color] : baseColors.snowWhite);
};

var shadowColor = (0, _toColorString.default)(_objectSpread({}, skyPlane.default.color, {
  alpha: skyPlane.default.opacity
}));

var PopoverArrow = _styledComponents.default.div.withConfig({
  displayName: "Arrow__PopoverArrow",
  componentId: "tdpdnl-0"
})(["overflow:hidden;position:absolute;", ";&::after{content:'';box-shadow:1px 1px ", "px ", ";height:", "px;position:absolute;transform:rotateZ(45deg) translateX(50%);width:", "px;", ";}"], getDynamicStyles, skyPlane.default.size, shadowColor, _constants.arrowSize.side, _constants.arrowSize.side, colorModifiers);

var _default = PopoverArrow;
exports.default = _default;